import { useRef, useEffect } from 'react';

import { menuItemClasses } from '@mui/material/MenuItem';
import Popover, { PopoverOrigin } from '@mui/material/Popover';

import { getPosition } from './utils';
import { StyledArrow } from './styles';
import { MenuPopoverProps } from './types';

export default function CustomPopover({
  open,
  children,
  arrow = 'top-right',
  hiddenArrow,
  sx,
  ...other
}: MenuPopoverProps) {
  const { style, anchorOrigin, transformOrigin } = getPosition(arrow);
  const firstMenuItemRef = useRef<HTMLDivElement | null>(null);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (open) {
      // Wait for the Popover to be fully rendered
      const timeoutId = setTimeout(() => {
        // Find the first menu item and focus it
        const firstMenuItem = firstMenuItemRef.current?.querySelector(
          '[role="menuitem"]'
        ) as HTMLElement;
        if (firstMenuItem) {
          firstMenuItem.focus();
        }
      }, 100);

      return () => clearTimeout(timeoutId);
    }
  }, [open]);

  return (
    <Popover
      open={Boolean(open)}
      anchorEl={open}
      anchorOrigin={anchorOrigin as PopoverOrigin}
      transformOrigin={transformOrigin as PopoverOrigin}
      slotProps={{
        paper: {
          sx: {
            width: 'auto',
            overflow: 'inherit',
            ...style,
            [`& .${menuItemClasses.root}`]: {
              '& svg': {
                mr: 2,
                flexShrink: 0,
              },
            },
            ...sx,
          },
        },
      }}
      {...other}
    >
      {!hiddenArrow && <StyledArrow arrow={arrow} />}

      <div ref={firstMenuItemRef}>{children}</div>
    </Popover>
  );
}
